module.exports = __webpack_public_path__ + "static/baseball-rendering-9f7a90157583321e288a5d762cca99fe.jpg";